export default "__VITE_ASSET__DdrPpIc3__"